import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Box, TextField } from '@mui/material';


interface PetDetailsSectionProps {
  control: Control<Gift.Crud>;
  dictionary: any;
}

const PetDetailsSection: React.FC<PetDetailsSectionProps> = ({ control, dictionary }) => {
  return (
    <Box>
      <Controller
        name="petName"
        control={control}
        rules={{ required: dictionary.forms.validations.required }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label="Pet Name"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            fullWidth
            slotProps={{
              input: {
                sx: {
                  'fieldset': {
                    borderRadius: '10px',
                  },
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default PetDetailsSection;
